import React from 'react';
import { AngleBackIcon } from '@/components/UI/Icons/Icons';
import { Button } from '@/components/UI/Button/Button';
import * as S from '@/components/Ad/ShopBanner/ShopBanner.styles';
import { Shop } from '@/api/types/common.types';

interface ShopBannerProps {
  shop?: Shop | null;
}

export const ShopBanner = ({ shop }: ShopBannerProps) => {
  if (!shop) return null;

  return (
    <S.Box href={shop.uri} dataTestId="shop-banner">
      {shop.logo?.url && (
        <S.Logo src={shop.logo.url} alt={shop.name} loading="lazy" />
      )}
      <S.Texts>
        <S.Name $variant="3">{shop.name}</S.Name>
        <S.Description $variant="4">{shop.description}</S.Description>
      </S.Texts>
      <Button
        appearance="transparent"
        hasPadding={false}
        aria-label="Shop link"
      >
        <AngleBackIcon isRotated />
      </Button>
    </S.Box>
  );
};
